export const goToHome = (navigate: any) => {
  navigate("/");
};
